import * as React from 'react';
export const zoominfoSvg = React.forwardRef(function zoominfoSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EA1B15',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M22.75 7h1.933c.176 0 .317.142.317.317v4.986a.32.32 0 0 1-.311.322h-1.622a.316.316 0 0 1-.317-.317V10.85l-12.507 11.9h3.19c.176 0 .317.142.317.317v1.616a.316.316 0 0 1-.317.317H7.317A.316.316 0 0 1 7 24.683V22.75l14.177-13.5h-1.485a.316.316 0 0 1-.317-.317v-1.61c0-.176.141-.317.317-.317L22.75 7ZM11.5 9.25l5.308-.005a.316.316 0 0 0 .317-.317V7.317A.315.315 0 0 0 16.814 7H7.328a.316.316 0 0 0-.317.317v4.992c0 .175.142.316.317.316h1.611a.311.311 0 0 0 .311-.317V9.25h2.25Zm11.25 13.5h-6.433a.316.316 0 0 0-.317.317v1.616c0 .176.141.317.317.317h8.366a.316.316 0 0 0 .317-.317v-5.017a.316.316 0 0 0-.317-.317h-1.616a.316.316 0 0 0-.317.317v3.084Z',
    }),
  );
});
zoominfoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var zoominfo = {
  category: 'brand',
  colorable: false,
  name: 'zoominfo',
  svg: zoominfoSvg,
};
